import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

import {
    messageToString,

    Tab,
    TabContainer,
} from '@ratehub/base-ui';

import { TabMessages } from '../definitions/TabValues';
import AccountDetailsHeader from './AccountDetailsHeader';
import DocumentHistoryTable from './DocumentHistoryTable';


function PageSavedDocuments({ model }) {
    const intl = useIntl();

    function handleTabChange(index) {
        model.selectTab(model.tabs[index].id);
    }

    return (
        <Container>
            <h1 className={classNames('rh-title-2xl', 'rh-mb-3', 'rh-mt-1_5')}>
                <FormattedMessage
                    {...TabMessages.WELCOME}
                    values={{
                        hasUserName: !!model.userName,
                        name: model.userName,
                    }}
                />
            </h1>

            <TabContainer
                orientation="verticalDropdown"
                initialTabIndex={model.selectedTabIndex}
                tabListSize="small"
                tabListVariant="dark"
                dropdownText={messageToString(TabMessages.DROPDOWN_LABEL, intl)}
                onTabChange={handleTabChange}
            >
                <For
                    each="tab"
                    of={model.tabs}
                >
                    <Tab
                        key={`saved-documents-tab-${tab.id}`}
                        title={messageToString(tab.tabTitle, intl)}
                        className="tab"
                    >
                        <AccountDetailsHeader
                            title={tab.headerTitle}
                            ctaLabel={tab.ctaLabel}
                            startQuoteHREF={tab.startQuoteHREF}
                        />
                        <DocumentHistoryTable
                            model={model}
                            RowComponent={tab.RowComponent}
                            shouldShowSpinner={model.shouldShowSpinner}
                            rows={tab.rows}
                        />
                    </Tab>
                </For>
            </TabContainer>
        </Container>
    );
}

PageSavedDocuments.propTypes = {
    model: PropTypes.object.isRequired,
};

PageSavedDocuments.defaultProps = {

};

const Container = styled.div`
    > .tab {
        max-width: 900px;
    }
`;

export default observer(PageSavedDocuments);
